
























import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
// Model, Inject, Emit, Prop, Watch
// import { Mutation, State, Action, Getter } from 'vuex-class';
@Component
export default class TipsModal extends Vue {
  @Prop({ type: Object, required: false }) private btnObj!: any;
  @Prop({ type: Boolean, required: false }) private isShow!: boolean;

    private screenHight: any;
    private marginTopTips: string = '';

    private mounted() {
        this.screenHight = document.documentElement.clientHeight;
    }

    @Watch('isShow')
    private onChangeValue(val: number, old: any) {
        const refelement = ( this.$refs.element as any );
        refelement.style.transform = 'translate3d(0%, ' + this.screenHight + 'px, 0)';
        this.marginTopTips = ( this.screenHight * 2 / 5 ) - (( refelement.getBoundingClientRect().height) / 2 ) + 'px';
        refelement.style.transform = 'translate3d(0%, ' + 0 + ', 0)';
        const modalWidth = ( refelement.getBoundingClientRect().width ) - 60;
        const spanWidh = refelement.getBoundingClientRect().width;
        if ( modalWidth <= spanWidh ) {
             ( this.$refs.spanWidth as any ).style.textAlign = 'left';
        } else {
             ( this.$refs.spanWidth as any ).style.textAlign = 'center';
        }
    }
}
